let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("40LPU")).then(() => parcelRequire('2SBvi'));